interface PointCloudProps {
  positions: Float32Array;
  /** Per-point RGB (0..1), packed to match `positions`. Built by the cache decode step. */
  colors: Float32Array;
  /** Point size in pixels (sizeAttenuation off → screen-space). */
  size?: number;
}

/**
 * Renders points as a single THREE.Points object. Purely a consumer of the two
 * buffers — height coloring now lives in the cache decode step so its bytes are
 * accounted for. Parent keys this by frame id, so buffers swap cleanly per frame.
 */
export function PointCloud({ positions, colors, size = 1.5 }: PointCloudProps) {
  return (
    <points frustumCulled={false}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" args={[positions, 3]} />
        <bufferAttribute attach="attributes-color" args={[colors, 3]} />
      </bufferGeometry>
      <pointsMaterial size={size} sizeAttenuation={false} vertexColors />
    </points>
  );
}
